// extracted by mini-css-extract-plugin
export default {"sliderContainer":"L8KtUs4Nnl"};